<div
  class="flex items-center justify-end w-full gap-2 sm:gap-4 lg:gap-6 text-base"
  *ngIf="!(currentUrl$ | async)?.startsWith('device-summary') && !(currentUrl$ | async)?.startsWith('account-profile')"
>
  <!-- Cache Update Info - Hidden on mobile, shown on larger screens -->
  <div class="hidden lg:flex items-center min-w-0">
    <!-- Info area - can be used by buttons for status messages -->
  </div>

  <!-- Dynamic Action Buttons Container -->
  <div class="flex items-center gap-2 sm:gap-4">
    <!-- Dynamically registered buttons -->
    <ng-container *ngFor="let button of dynamicButtons$ | async">
      <!-- Dropdown button -->
      <lib-cdw-dropdown-menu
        *ngIf="button.options && button.options.length > 0"
        [attr.data-testid]="'navbar-action-' + button.id"
        [class.disabled-button]="isButtonDisabled(button)"
        [buttonLabel]="button.label"
        [options]="button.options"
        [level]="button.level || 'primary'"
        [fontColor]="button.fontColor"
        [fontWeight]="button.fontWeight || 700"
        [fontSize]="button.fontSize || '14px'"
        [fontFamily]="button.fontFamily || 'Roboto'"
        [borderColor]="button.borderColor"
        [iconColor]="button.iconColor"
        [customIcon]="button.icon"
        [customIconSize]="button.iconSize || '24px'"
        [customIconPosition]="button.iconPosition || 'left'"
        [useMatIcon]="button.useMatIcon !== false"
        [panelWidth]="button.panelWidth"
        [panelPosition]="button.panelPosition || 'after'"
        [mode]="button.mode === 'wide' ? 'wide' : undefined"
        [buttonWidth]="button.buttonWidth"
        [infoText]="button.infoText"
        [infoBackgroundColor]="button.infoBackgroundColor"
        [infoFontColor]="button.infoFontColor"
        [infoFontFamily]="button.infoFontFamily"
        [infoFontSize]="button.infoFontSize"
        [infoFontWeight]="button.infoFontWeight"
        [disabled]="isButtonDisabled(button)"
        [disabledTooltip]="button.disabledTooltip"
        (optionSelected)="handleOptionSelected(button, $event)">
      </lib-cdw-dropdown-menu>

      <!-- Simple button (no dropdown) -->
      <lib-cdw-button
        *ngIf="!button.options || button.options.length === 0"
        [attr.data-testid]="'navbar-action-' + button.id"
        [class.disabled-button]="isButtonDisabled(button)"
        [matTooltip]="isButtonDisabled(button) ? (button.disabledTooltip || '') : ''"
        [mode]="button.mode || 'standard'"
        [level]="button.level || 'primary'"
        [icon]="button.icon || ''"
        [useMatIcon]="button.useMatIcon !== false"
        [fontFamily]="button.fontFamily"
        [fontWeight]="button.fontWeight"
        [fontSize]="button.fontSize"
        [fontColor]="button.fontColor"
        [customIconColor]="button.iconColor"
        [iconSize]="button.iconSize"
        [buttonWidth]="button.buttonWidth"
        [disabled]="isButtonDisabled(button)"
        (buttonClick)="handleButtonClick(button)">
        {{ button.label }}
      </lib-cdw-button>
    </ng-container>
  </div>
</div>
